// Module
var code = "<p>בעמוד של כל מודעה תוכלו “לטייל” ולראות איך נראים המבנה וסביבתו. פשוט היכנסו לעמוד המודעה, גלגלו מטה, ולחצו על לחצן ה”מבט רחוב” שמופיע בחלק השמאלי התחתון של המפה. עכשיו צאו לטיול ביום בהיר בשכונה באמצעות הזזת העכבר תוך לחיצה על הלחצן השמאלי שלו. אם תקישו על נקודה מסוימת במרחב, תצוגת המפה תנוע לעברה.</p> ";
// Exports
export default code;